<template>
  <div>
    <Modal :visible="visible" @cancel="$emit('cancel')" class="h-5/6">
      <div class="title">{{ process }}</div>
      <p class="exp1 text-base font-bold">同行者申請とは...<br>本宿泊予約において、ポイント・補助クーポンをお持ちの会員様と同行される場合に申請できます。<br>※お申込み時にすでに申請された方は再申請は不要です<br></p>
      <p class="exp2 text-base font-bold">※すでに申請済みの内容は変更できません<br>※申請上限を超えた場合、同行者を追加することはできません</p>
      <div
        class="form-attach"
        v-for="(item, index) in formAttach"
        :key="`form-attach-${index}`"
      >
        <div class="form-input1">
          <div class="input-title1">同行者の申請</div>
          <p class="input-name-title">氏名</p>
          <a-input
            @change="replaceSpecialInputFirstname(item)"
            @blur="validateFirstName(item)"
            @input="validateFirstName(item)"
            @keypress="validateSpecialChar($event)"
            :maxLength="100"
            v-model.trim="item.firstName"
            type="text"
            placeholder="姓"
            :class="{ 'validation-error': item.errorFirstName }"
            wovn-ignore
          />
          <a-input
            @change="replaceSpecialInputFamilyname(item)"
            @blur="validateFamilyName(item)"
            @input="validateFamilyName(item)"
            @keypress="validateSpecialChar($event)"
            :maxLength="100"
            v-model.trim="item.familyName"
            type="text"
            placeholder="名"
            :class="{ 'validation-error': item.errorFamilyName }"
            wovn-ignore
          />
          <div></div>
          <div class="font-bold text-primary">
            {{ item.errorFirstName }}
          </div>
          <div class="font-bold text-primary">
            {{ item.errorFamilyName }}
          </div>
          <p class="input-email-title">メールアドレス</p>
          <a-input
            :maxLength="255"
            v-model.trim="item.email"
            type="text"
            placeholder="one@benefit.jp"
            class="input-email"
            @blur="validateEmail(item)"
            @input="validateEmail(item)"
            :class="{ 'validation-error': item.errorEmail }"
            wovn-ignore
          />
          <div></div>
          <div style="width: 300px" class="font-bold text-primary">
            {{ item.errorEmail }}
          </div>
        </div>
      </div>

      <div class="add-introduce w-full text-right"  v-if="process == '同行者申請'">
        <a class="text-black" @click="addPerson">
          宿泊同行者を追加する
          <span class="icon icon-plus-action">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </span>
        </a>
      </div>

      <div class="btn-cms" v-if="process == '同行者申請'">
        <button @click="sendEmail" class="c-btn btn-grey">
          <span class="">招待メールを送信する</span>
        </button>
      </div>
      <div class="btn-cms" v-if="process == '同行者の補助金・ポイント申請'">
        <button @click="sendSubsidyEmail" class="c-btn btn-grey">
          <span class="">招待メールを送信する</span>
        </button>
      </div>
    </Modal>
    <div>
      <a-modal 
        ok-text = "OK"
        cancel-text="閉じる"
        :visible="visiblePopupSendMail"
        @ok="closeSendmail"        
        @cancel="closeSendmail">
        <p>メール送信完了しました</p>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { Modal } from '@/components/primitive'
import func_utils from '@/mixins/func_utils'

export default {
  mixins: [func_utils],
  components: {
    Modal
  },
  props: {
    acptNo: { type: String, default: '' },
    acptDtlNo: { type: String, default: '' },
    process:{type: String, default: ''},
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visiblePopupSendMail: false,
      formAttach: [
        {
          firstName: '',
          name: '',
          email: '',
          errorFirstName: '',
          errorFamilyName: '',
          errorEmail: '',
          acptDtlNo: ''
        }
      ],
      hasError: false
    }
  },
  created() {
    this.resetData()
  },
  watch: {
    visible() {
      this.resetData()
    }
  },
  methods: {
    showPopUpSendMail() {
      this.visiblePopupSendMail = true
    },
    closeSendmail() {
      this.visiblePopupSendMail = false
    },
    replaceSpecialInputFirstname(item) {
      item.firstName = this.onReplaceSpecialChar(item.firstName)
    },
    replaceSpecialInputFamilyname(item) {
      item.familyName = this.onReplaceSpecialChar(item.familyName)
    },
    resetData() {
      this.hasError = false
      this.formAttach = [
        {
          firstName: '',
          familyName: '',
          email: '',
          errorFirstName: '',
          errorFamilyName: '',
          errorEmail: ''
        }
      ]
    },
    async sendEmail() {
      this.validateForm()
      if (!this.hasError) {
        await this.handleSendMail(this.acptNo, this.buildSendData())
        this.$emit('ok')
      }
    },
    buildSendData() {
      let sendData = [...this.formAttach]
      sendData.forEach((item) => {
        delete item.errorFirstName
        delete item.errorFamilyName
        delete item.errorEmail
        item.acptDtlNo = this.acptDtlNo
        return item
      })
      sendData = { companionInfoList: sendData.filter((item) => item.email) }
      return sendData
    },
    async handleSendMail(acptNo, sendData) {
      const messageSuccess = '招待メールを送信しました。'
      let numberAttach = ''
      await this.$repositories('order')
        .sendAddingUserEmail(acptNo, sendData)
        .then(
          () => {
            this.$toasted.success(numberAttach + messageSuccess)
          },
          () => {
            this.$toasted.error('コンパニオン登録に失敗しました')
          }
        )
        .catch((err) => {
          console.error('handleSendMail', err)
        })
    },
    // 同行者助成申請
    async sendSubsidyEmail(){
      this.validateForm()
      if (!this.hasError) {
        await this.handleSendSubsidyMail(this.acptNo, this.buildSendData())
        this.$emit('ok')
      }
    },
    // 同行者情報登録,メール送信
    async handleSendSubsidyMail(acptNo, sendData) {
      const messageSuccess = '招待メールを送信しました。';
      let numberAttach = ''
      let companionEntryId = ''
      let emailTo = sendData.companionInfoList[0].email
      let errorCode = "";
      let errorDetail = "";

      // API：同行者情報登録
      await this.$repositories('order')
        .sendAddingUserSubsidyEmail(acptNo, sendData)
        .then(
          (res) => {
              console.log("response:",res);
              companionEntryId = res.data.companionEntryId[0]
              this.$toasted.success(numberAttach + '同行者情報登録に成功しました')
            },
            (res) => {
              this.$toasted.error(numberAttach + '同行者登録に失敗しました')
              errorCode = res.data.errorCode
              errorDetail = res.data.errorDetail

              console.log("エラーコード:", errorCode)
              console.log("エラー詳細:", errorDetail)
              
              if(errorCode === "0120" || errorCode === "0101"){
                this.$toasted.error(errorDetail)
              } else {
                this.$toasted.error("システムエラーが発生しました")
              }
              console.error('handleSendSubsidyMail', res)
            }
          )
          .catch((err) => {
            console.error('handleSendSubsidyMail', err)
          }
        )
      
      if(errorCode === ""){
        const fellowTravelersReqParam = {
          acptNo : acptNo,
          companionEntryId : companionEntryId,
          emailTo : emailTo
        }
        // API：URL作成,メール送信
        await this.$repositories('order')
          .sendMailToCopanionSubsidy(fellowTravelersReqParam)
          .then(
            (res) => {
              this.$toasted.success(numberAttach + messageSuccess)
              this.showPopUpSendMail()
            },
            (res) => {
              this.$toasted.error('メール送信に失敗しました')
            }
          )
          .catch((err) => {
            console.error('handleSendSubsidyMail', err)
          })
      }
        
    },
    validateFirstName(item) {
      if (!item.firstName) {
        item.errorFirstName = '姓を入力してください'
        this.hasError = true
      } else {
        item.errorFirstName = ''
      }
    },
    validateFamilyName(item) {
      if (!item.familyName) {
        item.errorFamilyName = '名を入力してください'
        this.hasError = true
      } else {
        item.errorFamilyName = ''
      }
    },
    validateEmail(item) {
      if (!item.email) {
        item.errorEmail = 'メールアドレスを入力してください'
        this.hasError = true
      } else if (!this.validEmail(item.email)) {
        item.errorEmail = 'メールアドレスの形式が不正です'
        this.hasError = true
      } else {
        item.errorEmail = ''
      }
    },

    validateForm() {
      this.hasError = false
      this.formAttach.forEach((item) => {
        this.validateFirstName(item)
        this.validateFamilyName(item)
        this.validateEmail(item)
      })
      if(this.hasError){
        this.$toasted.error('同行者情報は必須項目です。')
      }
    },
    addPerson() {
      this.formAttach.push({
        firstName: '',
        familyName: '',
        email: '',
        errorFirstName: '',
        errorFamilyName: '',
        errorEmail: '',
        acptDtlNo: ''
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
